module.exports = __webpack_public_path__ + "static/media/d1.aa824f6b.jpg";